const initialState = {
  addressSearch: {
    fetchingAddresses: {},
    addresses: {},
    address: {},
  },
};

export default initialState;
